var exports = {
  "Nr": "StreamWatchHoverCard.module__card___UE1iQT",
  "Br": "StreamWatchHoverCard.module__variantCompact___UE1iQT",
  "wy": "StreamWatchHoverCard.module__variantList___UE1iQT",
  "VH": "StreamWatchHoverCard.module__preview___UE1iQT",
  "sf": "StreamWatchHoverCard.module__previewCompact___UE1iQT",
  "$8": "StreamWatchHoverCard.module__previewList___UE1iQT",
  "oz": "StreamWatchHoverCard.module__previewImage___UE1iQT",
  "nZ": "StreamWatchHoverCard.module__previewFallback___UE1iQT",
  "SV": "StreamWatchHoverCard.module__compactButtonWrap___UE1iQT",
  "Iq": "StreamWatchHoverCard.module__compactButton___UE1iQT",
  "$l": "StreamWatchHoverCard.module__actionRow___UE1iQT",
  "uu": "StreamWatchHoverCard.module__actionButtons___UE1iQT",
  "jb": "StreamWatchHoverCard.module__listButton___UE1iQT",
  "fX": "StreamWatchHoverCard.module__previewClickable___UE1iQT",
  "FC": "StreamWatchHoverCard.module__previewHoverOverlay___UE1iQT",
  "Mp": "StreamWatchHoverCard.module__previewHoverText___UE1iQT",
  "z0": "StreamWatchHoverCard.module__protipRow___UE1iQT",
  "cm": "StreamWatchHoverCard.module__protipText___UE1iQT",
};

module.exports = exports;
